import React from "react";

import { Outlet, useOutletContext } from "react-router";

export default function DetailsPageWrapper() {
    // Forward the SiteWrapper outlet context (setDefaultSearch) so builder
    // pages can seed the header search form.
    return (
        <div>
            <Outlet context={useOutletContext()} />
        </div>
    );
}
